import { render, staticRenderFns } from "./BadgeImage.vue?vue&type=template&id=00fd7e16&scoped=true&"
import script from "./BadgeImage.vue?vue&type=script&lang=js&"
export * from "./BadgeImage.vue?vue&type=script&lang=js&"
import style0 from "./BadgeImage.vue?vue&type=style&index=0&id=00fd7e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd7e16",
  null
  
)

export default component.exports